import React from 'react';
import { Link } from 'react-router-dom';
import PosterCard from './PosterCard';
import '../styles/SearchResultCard.css';

// Renders `snippet` with the literal matched substring wrapped in <mark> - only for
// direct matches, `matchedText` is null for fuzzy matches (nothing to highlight).
const HighlightedSnippet = ({ snippet, matchedText }) => {
  if (!matchedText) return <>{snippet}</>;
  const idx = snippet.toLowerCase().indexOf(matchedText.toLowerCase());
  if (idx === -1) return <>{snippet}</>;
  return (
    <>
      {snippet.slice(0, idx)}
      <mark>{snippet.slice(idx, idx + matchedText.length)}</mark>
      {snippet.slice(idx + matchedText.length)}
    </>
  );
};

const SearchResultCard = ({ item }) => {
  const match = item.search_match;
  const link = `/media-item/${item.id}`;

  return (
    <div className="search-result-card">
      <PosterCard media={item} />
      <Link to={link} className="search-result-reason">
        <span className="search-result-reason-label">
          {match.label}
          {!match.is_direct && <span className="search-result-fuzzy-badge">similar</span>}
        </span>
        <p className="search-result-reason-snippet">
          <HighlightedSnippet snippet={match.snippet} matchedText={match.matched_text} />
        </p>
      </Link>
    </div>
  );
};

export default SearchResultCard;
